import { render, staticRenderFns } from "./BaseSwiper.vue?vue&type=template&id=dcd3a1ae&scoped=true&"
import script from "./BaseSwiper.vue?vue&type=script&lang=js&"
export * from "./BaseSwiper.vue?vue&type=script&lang=js&"
import style0 from "./BaseSwiper.vue?vue&type=style&index=0&id=dcd3a1ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd3a1ae",
  null
  
)

export default component.exports